import CancelModal from '@/app/common/components/CancelModal';
import useDomain from '@/hooks/useDomain';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { errorMessage, successMessage } from '@/utils/toast';
import { useDeleteKeywordsMutation } from '@/app/KeywordTracker/api/keywordsApi';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { deleteTransaction } from '@/app/common/components/ag-grid/deleteTransaction';
import { hideModal } from '@/app/common/reducers/simpleModal';

const DeleteKeywords = ({ gridRef, setShouldRevalidateFirstPage }) => {
  const [deleteKeywords] = useDeleteKeywordsMutation();
  const { domain_slug } = useDomain();
  const selectedKeys = useSelector(state => state.selectedKeys);
  const modalKey = useSelector(state => state.simpleModal);
  const dispatch = useDispatch();
  return (
    <CancelModal
      desc={
        <Form.Group>
          <Form.Label>
            آیا از حذف {selectedKeys.length} کلمه کلیدی زیر مطمئن هستی؟
          </Form.Label>
          <Form.Control
            disabled
            rows={selectedKeys.length > 3 ? 3 : selectedKeys.length}
            as="textarea"
            value={selectedKeys.map(({ label }) => `${label}`).join('\n')}
          />
          <div className="d-flex mt-2 align-items-center gap-2">
            <FontAwesomeIcon
              icon="exclamation-circle"
              className="text-warning"
            />
            پس از حذف، تمام اطلاعات وابسته به کلمه پاک خواهد شد.
          </div>
        </Form.Group>
      }
      show={modalKey === 'DELETE_KEYWORD'}
      setShow={() => {
        dispatch(hideModal());
      }}
      title="حذف کلمه کلیدی"
      submitFunc={() => {
        deleteKeywords({
          domain_slug,
          keyword_ids: selectedKeys.map(key => key.id)
        })
          .unwrap()
          .then(res => {
            setShouldRevalidateFirstPage(true);
            deleteTransaction(res?.data, gridRef);
            successMessage('حذف کلمات با موفقیت انجام شد.');
          })
          .catch(err => {
            errorMessage('خطایی در حذف کلمات وجود داره');
            console.error(err);
          })
          .finally(() => {
            dispatch(hideModal());
          });
      }}
      submitTitle="آره، حذف بشه"
    />
  );
};

export default DeleteKeywords;
